import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';

import { Button } from 'app-core';
import { MedicinesService } from 'app-service';
import { Subject, takeUntil } from 'rxjs';

import ButtonType = Data.Core.ButtonType;

@Component({
  selector: 'app-dummy-data-medicines',
  templateUrl: './medicines.component.html',
  styleUrls: ['./medicines.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [MedicinesService],
})
export class DummyDataMedicinesComponent {
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  public medicinesCount: number = 0;
  public createMedicinesButton: Button = new Button({
    label: 'Create Medicines DB',
    type: ButtonType.button,
    action: () => this.createMedicineDatabase(),
    disabled: () => !!this.medicinesCount,
  });
  public getMedicinesButton: Button = new Button({
    label: 'Get Medicines Count',
    type: ButtonType.button,
    action: () => this.getDummyCouponsCount(),
    disabled: () => !!this.medicinesCount,
  });

  public constructor(
    private readonly _cdRef: ChangeDetectorRef,
    private readonly _medicinesService: MedicinesService,
  ) {}

  public ngOnInit(): void {
    this.getDummyCouponsCount();
  }

  private createMedicineDatabase(): void {
    this._medicinesService
      .createMedicineDatabase()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        () => {},
        () => {},
        () => {
          this.getDummyCouponsCount();
        },
      );
  }

  private getDummyCouponsCount(): void {
    this._medicinesService
      .getAllMedicineCount()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((count: any) => {
        this.medicinesCount = count.count;
        this._cdRef.markForCheck();
      });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
